import _ from 'lodash';

const _fetchMethods = {
  _cities(prefectureId) {
    return this.$http.get('/api/city/get', {
      params: {
        prefecture_id: prefectureId,
        exclude_god: true
      }
    }).then((res) => _.get(res.data, 'cities', null));
  },
};

export default {
  data() {
    return {
      isDisabled: false
    };
  },
  methods: {
    fetchMaster(name, key) {
      const fetchFunc = _.get(_fetchMethods, `_${name}`, null);
      if (_.isNull(fetchFunc)) {
        throw new Error(`${name}メソッドは存在しません.`);
      }

      let value;
      if (typeof key !== 'object') {
        value = this.$store.getters.getValueByKey(key);
      }

      this.isDisabled = 'disabled';
      return fetchFunc.call(this, value).then((master) => {
        if (master) this.isDisabled = false;
        return master;
      });
    },
    setWatcher(key) {
      this.$store.watch((state) => _.get(state.value, key), () => {
        this.validate = false; // 一時的にvalidateをfalseにする。
        this.fetchMaster(this.refMaster, this.refObserveKey).then((data) => {
          this.fetchedMaster = data;

          // フォームの値が取得したマスターの値に含まれていない場合のみ値を初期化
          if (!_.includes(_.map(this.fetchedMaster, this.refItemValueKey), this.formValue)) {
            this.$store.commit('setValue', {[this.refName]: ''});
          }

          if (this.isValidate) {
            this.$store.dispatch('initializeValidate', {data: {[this.refName]: ''}, path: this.formUrl}).then(() => {
              this.$emit('initialize-validated');
            });
          }
          this.$store.commit('deleteError', this.refName);
          this.validate = this.isValidate;
        });
      });
    }
  }
};
